import { UPLOADABLE_DOCUMENT_TYPES, UPLOADABLE_MOVIE_TYPES } from "#lib/components/images/constants.js";

export function getFileIcon(mimeType: string | undefined): { iconSet: string; name: string } {
	if (!mimeType) return { iconSet: "flowcode", name: "folder-solid" };
	if (UPLOADABLE_MOVIE_TYPES.includes(mimeType)) {
		return { iconSet: "heroicons", name: "film" };
	} else if (UPLOADABLE_DOCUMENT_TYPES.includes(mimeType)) {
		return { iconSet: "heroicons", name: "document" };
	}
	return { iconSet: "heroicons", name: "photo" };
}
